import script from "./MdmToolsExport.vue?vue&type=script&setup=true&lang=js"
export * from "./MdmToolsExport.vue?vue&type=script&setup=true&lang=js"

import "./MdmToolsExport.vue?vue&type=style&index=0&id=b36f56b0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b36f56b0"]])

export default __exports__